import { SignInPage } from '@backstage/core-components'
import { oktaAuthApiRef } from '@backstage/frontend-plugin-api'
import { SignInPageBlueprint } from '@backstage/plugin-app-react'

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        provider={{
          id: 'okta',
          title: 'Veho SSO',
          message: 'Sign in using Veho Single Sign-On',
          apiRef: oktaAuthApiRef,
        }}
      />
    ),
  },
})
